import { createAction, props } from '@ngrx/store';
import { JobsDto } from 'src/app/data/dtos';

export const getJobsData = createAction(
  '[Jobs] getJobsData',
  props<{ jobsQuery: string }>(),
);
export const getJobsDataSuccess = createAction(
  '[Jobs] getJobsData success',
  props<JobsDto>(),
);
export const getJobsDataFailure = createAction(
  '[Jobs] getJobsData failure',
  props<{ error: string }>(),
);
export const resetJobsData = createAction(
  '[Jobs] resetJobsData',
);


export const getJobFavoritesData = createAction('[Jobs] getJobFavoritesData');
export const getJobFavoritesDataSuccess = createAction(
  '[Jobs] getJobFavoritesData success',
  props<{jobSlugs: string[]}>(),
);
export const getJobFavoritesDataFailure = createAction(
  '[Jobs] getJobFavoritesData failure',
  props<{ error: string }>(),
);
export const resetJobFavoritesData = createAction(
  '[Jobs] resetJobFavoritesData',
);


